import ArrowLeftCircleSVG from "../../../assets/icons/arrow-left-circle.svg"
export const ArrowLeftCircle: React.FC = () => {
  return (
    <img src={ArrowLeftCircleSVG} alt="" className="w-[20px] h-[20px] cursor-pointer" />
  )
}
